import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

function sectionCardImgCta2Adapter(data: any): any {
    console.log(JSON.parse(data.descripcion.raw))
    return {
        heading: data.tituloGeneral ?? '',
        description: data.descripcion ? documentToPlainTextString(JSON.parse(data.descripcion.raw)) : '',
        cards:
            data?.referenciaPlantillaContenido?.map((card: any) => ({
                title: card.tituloBanner ?? '',
                description: card.descripcion ? documentToPlainTextString(JSON.parse(card.descripcion.raw)) : '',
                img: card.imagenPrincipal ? card.imagenPrincipal[0].file.url : '',
                imgPosition: card.posicionImagen ? card.posicionImagen.toLowerCase() : 'left',
                ctaAction: data.redireccionBoton ? data.redireccionBoton : '',
                ctaLabel: data.tituloBoton ? data.tituloBoton : 'Conocer más'
            })) ?? [],
        items: data?.referenciaPlantillaContenido?.map((item: any, index: number) => ({
            id: index,
            label: item.tituloDescripcion
        })) ?? []
    }
};


export default sectionCardImgCta2Adapter;
